import {
  GeneralPermissions,
  SettingsPermissions,
} from "@redotech/account-common/permissions";
import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { TeamType } from "@redotech/account-common/team-type";
import { MarketingFlagKey } from "@redotech/feature-flags-keys-marketing/keys";
import { OmsFlagKey } from "@redotech/feature-flags-keys-oms/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import ActivityHeartIcon from "@redotech/redo-icons/activity-heart.svg";
import ActivityHeartFilledIcon from "@redotech/redo-icons/activity-heart_filled.svg";
import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";
import AlertCircleFilledIcon from "@redotech/redo-icons/alert-circle_filled.svg";
import Announcement02Icon from "@redotech/redo-icons/announcement-02.svg";
import Announcement02FilledIcon from "@redotech/redo-icons/announcement-02_filled.svg";
import Award01Icon from "@redotech/redo-icons/award-01.svg";
import Award01FilledIcon from "@redotech/redo-icons/award-01_filled.svg";
import BarChart01Icon from "@redotech/redo-icons/bar-chart-01.svg";
import BarChart01FilledIcon from "@redotech/redo-icons/bar-chart-01_filled.svg";
import Bell03Icon from "@redotech/redo-icons/bell-03.svg";
import Bell03FilledIcon from "@redotech/redo-icons/bell-03_filled.svg";
import Brush01Icon from "@redotech/redo-icons/brush-01.svg";
import Brush01FilledIcon from "@redotech/redo-icons/brush-01_filled.svg";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import Coins01Icon from "@redotech/redo-icons/coins-01.svg";
import Coins01FilledIcon from "@redotech/redo-icons/coins-01_filled.svg";
import CoinsStacked03Icon from "@redotech/redo-icons/coins-stacked-03.svg";
import CoinsStacked03FilledIcon from "@redotech/redo-icons/coins-stacked-03_filled.svg";
import CreditCard01Icon from "@redotech/redo-icons/credit-card-01.svg";
import CreditCard01FilledIcon from "@redotech/redo-icons/credit-card-01_filled.svg";
import Cursor01Icon from "@redotech/redo-icons/cursor-01.svg";
import Cursor01FilledIcon from "@redotech/redo-icons/cursor-01_filled.svg";
import DatabaseIcon from "@redotech/redo-icons/database-02.svg";
import DatabaseFilledIcon from "@redotech/redo-icons/database-02_filled.svg";
import DataflowIcon from "@redotech/redo-icons/dataflow-03.svg";
import DataflowFilledIcon from "@redotech/redo-icons/dataflow-03_filled.svg";
import FileCheck02Icon from "@redotech/redo-icons/file-check-02.svg";
import FileCheck02FilledIcon from "@redotech/redo-icons/file-check-02_filled.svg";
import FilterLinesIcon from "@redotech/redo-icons/filter-lines.svg";
import FilterLinesFilledIcon from "@redotech/redo-icons/filter-lines_filled.svg";
import FlipBackwardIcon from "@redotech/redo-icons/flip-backward.svg";
import FlipBackwardFilledIcon from "@redotech/redo-icons/flip-backward_filled.svg";
import Globe02Icon from "@redotech/redo-icons/globe-02.svg";
import Globe02FilledIcon from "@redotech/redo-icons/globe-02_filled.svg";
import Inbox01Icon from "@redotech/redo-icons/inbox-01.svg";
import Inbox01FilledIcon from "@redotech/redo-icons/inbox-01_filled.svg";
import Key01Icon from "@redotech/redo-icons/key-01.svg";
import Key01FilledIcon from "@redotech/redo-icons/key-01_filled.svg";
import LayersThree02Icon from "@redotech/redo-icons/layers-three-02.svg";
import LayersThree02FilledIcon from "@redotech/redo-icons/layers-three-02_filled.svg";
import LayoutGrid01Icon from "@redotech/redo-icons/layout-grid-01.svg";
import LayoutGrid01FilledIcon from "@redotech/redo-icons/layout-grid-01_filled.svg";
import ListIcon from "@redotech/redo-icons/list.svg";
import ListFilledIcon from "@redotech/redo-icons/list_filled.svg";
import Lock01Icon from "@redotech/redo-icons/lock-01.svg";
import Lock01FilledIcon from "@redotech/redo-icons/lock-01_filled.svg";
import Mail01Icon from "@redotech/redo-icons/mail-01.svg";
import Mail01FilledIcon from "@redotech/redo-icons/mail-01_filled.svg";
import Map01Icon from "@redotech/redo-icons/map-01.svg";
import Map01FilledIcon from "@redotech/redo-icons/map-01_filled.svg";
import MessageChatCircleIcon from "@redotech/redo-icons/message-chat-circle.svg";
import MessageChatCircleFilledIcon from "@redotech/redo-icons/message-chat-circle_filled.svg";
import MessageSquare01Icon from "@redotech/redo-icons/message-square-01.svg";
import MessageSquare01FilledIcon from "@redotech/redo-icons/message-square-01_filled.svg";
import Monitor01Icon from "@redotech/redo-icons/monitor-01.svg";
import Monitor01FilledIcon from "@redotech/redo-icons/monitor-01_filled.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import PackageFilledIcon from "@redotech/redo-icons/package_filled.svg";
import Pencil01Icon from "@redotech/redo-icons/pencil-01.svg";
import Pencil01FilledIcon from "@redotech/redo-icons/pencil-01_filled.svg";
import Phone01Icon from "@redotech/redo-icons/phone-01.svg";
import Phone01FilledIcon from "@redotech/redo-icons/phone-01_filled.svg";
import RefreshCw01Icon from "@redotech/redo-icons/refresh-cw-01.svg";
import RefreshCw01FilledIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import Route01Icon from "@redotech/redo-icons/route.svg";
import Route01FilledIcon from "@redotech/redo-icons/route_filled.svg";
import Settings02Icon from "@redotech/redo-icons/settings-02.svg";
import Settings02FilledIcon from "@redotech/redo-icons/settings-02_filled.svg";
import Share07Icon from "@redotech/redo-icons/share-07.svg";
import Share07FilledIcon from "@redotech/redo-icons/share-07_filled.svg";
import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import ShieldTickFilledIcon from "@redotech/redo-icons/shield-tick_filled.svg";
import ShoppingBag01Icon from "@redotech/redo-icons/shopping-bag-01.svg";
import ShoppingBag01FilledIcon from "@redotech/redo-icons/shopping-bag-01_filled.svg";
import ShoppingCart01Icon from "@redotech/redo-icons/shopping-cart-01.svg";
import ShoppingCart01FilledIcon from "@redotech/redo-icons/shopping-cart-01_filled.svg";
import Stars01Icon from "@redotech/redo-icons/stars-01.svg";
import Stars01FilledIcon from "@redotech/redo-icons/stars-01_filled.svg";
import Tag01Icon from "@redotech/redo-icons/tag-01.svg";
import Tag01FilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import Target01Icon from "@redotech/redo-icons/target-01.svg";
import Target01FilledIcon from "@redotech/redo-icons/target-01_filled.svg";
import Tool01Icon from "@redotech/redo-icons/tool-01.svg";
import Tool01FilledIcon from "@redotech/redo-icons/tool-01_filled.svg";
import Truck01Icon from "@redotech/redo-icons/truck-01.svg";
import Truck01FilledIcon from "@redotech/redo-icons/truck-01_filled.svg";
import User01Icon from "@redotech/redo-icons/user-01.svg";
import User01FilledIcon from "@redotech/redo-icons/user-01_filled.svg";
import UserCheck01Icon from "@redotech/redo-icons/user-check-01.svg";
import UserCheck01FilledIcon from "@redotech/redo-icons/user-check-01_filled.svg";
import UserCircleIcon from "@redotech/redo-icons/user-circle.svg";
import UserCircleFilledIcon from "@redotech/redo-icons/user-circle_filled.svg";
import UserEditIcon from "@redotech/redo-icons/user-edit.svg";
import UserEditFilledIcon from "@redotech/redo-icons/user-edit_filled.svg";
import Users01Icon from "@redotech/redo-icons/users-01.svg";
import Users01FilledIcon from "@redotech/redo-icons/users-01_filled.svg";
import UsersPlusIcon from "@redotech/redo-icons/users-plus.svg";
import UsersPlusFilledIcon from "@redotech/redo-icons/users-plus_filled.svg";
import WarehouseIcon from "@redotech/redo-icons/warehouse.svg";
import WarehouseFilledIcon from "@redotech/redo-icons/warehouse_filled.svg";
import XCircleIcon from "@redotech/redo-icons/x-circle.svg";
import XCircleFilledIcon from "@redotech/redo-icons/x-circle_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import ZapFilledIcon from "@redotech/redo-icons/zap_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useTeamFeatureFlag } from "@redotech/redo-merchant-app-common/use-team-feature-flag";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { RegistrationRewardType } from "@redotech/redo-return-warranties-common/extended-warranty";
import {
  SettingItem,
  SettingsSection,
  SettingsSectionEnum,
} from "@redotech/redo-web/arbiter-components/navigation/redo-settings-nav";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { filterTruthy } from "@redotech/util/array";
import { useContext } from "react";
import { INTEGRATIONS_HUB_PERMISSIONS } from "../../../integrations/catalog/catalog-data";
import { useDisputeAlertsEnrollmentEnabled } from "../../../payments/chargebacks/use-dispute-alerts-enrollment-enabled";
import { useDisputeResolveEnabled } from "../../../payments/chargebacks/use-dispute-resolve-enabled";
import { ConversionSuiteStatusesContext } from "../../../redo-suite/conversion-cloud";
import { MarketingCloudStatusesContext } from "../../../redo-suite/marketing-cloud";
import { OrderManagementSuiteStatusesContext } from "../../../redo-suite/order-management-cloud";
import { SupportSuiteStatusesContext } from "../../../redo-suite/support-cloud";
import { addSettingsCatalogSearchTerms } from "./settings-navigation-search";

export function useSettingsItems(): SettingsSection[] | null {
  const routes = useRequiredContext(MerchantRoutesContext);
  const generalSettings = useGeneralSettings();
  const personalSettings = usePersonalSettings();
  const aiSettings = useAiSettings();
  // const catalogSettings = useCatalogSettings();
  const conversionSettings = useConversionSettings();
  const chargebacksSettings = useChargebacksSettings();
  const customersSettings = useCustomersSettings();
  const inventoryManagementSettings = useInventoryManagementSettings();
  const marketingSettings = useMarketingSettings();
  const orderTrackingSettings = useOrderTrackingSettings();
  const productsSettings = useProductsSettings();
  const returnsSettings = useReturnsSettings();
  const warrantiesSettings = useWarrantiesSettings();
  const fulfillmentSettings = useFulfillmentSettings();
  const shippingSettings = useShippingSettings();
  const internationalSettings = useInternationalSettings();
  const supportSettings = useSupportSettings();

  const allSettingsItems: SettingsSection[] = filterTruthy([
    generalSettings,
    aiSettings,
    // catalogSettings,
    conversionSettings,
    chargebacksSettings,
    customersSettings,
    fulfillmentSettings,
    inventoryManagementSettings,
    marketingSettings,
    orderTrackingSettings,
    personalSettings,
    productsSettings,
    returnsSettings,
    shippingSettings,
    internationalSettings,
    supportSettings,
    warrantiesSettings,
  ]);

  return addSettingsCatalogSearchTerms({
    routes,
    sections: allSettingsItems,
    viewerVisibility: "merchant",
  });
}

function useAiSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );

  if (!canManageAiSettings) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "ai-general",
      href: routes.getSettingsSubRoute("ai/general"),
      friendlyName: "General",
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    {
      id: "ai-knowledge",
      href: routes.getSettingsSubRoute("ai/knowledge"),
      friendlyName: "Knowledge",
      UnfilledIcon: Stars01Icon,
      FilledIcon: Stars01FilledIcon,
    },
    {
      id: "ai-skills",
      href: routes.getSettingsSubRoute("ai/skills"),
      friendlyName: "Skills",
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.AI, items };
}

function useChargebacksSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { enabled: alertsEnabled } = useDisputeAlertsEnrollmentEnabled();
  const { enabled: resolveEnabled } = useDisputeResolveEnabled();

  if (!team.settings.disputes?.enabled) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "chargebacks-profile",
      href: routes.getSettingsSubRoute("chargebacks/profile"),
      friendlyName: "Reclaim Profile",
      UnfilledIcon: User01Icon,
      FilledIcon: User01FilledIcon,
    },
    {
      id: "chargebacks-reclaim",
      href: routes.getSettingsSubRoute("chargebacks/reclaim"),
      friendlyName: "Reclaim",
      UnfilledIcon: CreditCard01Icon,
      FilledIcon: CreditCard01FilledIcon,
    },
    alertsEnabled && {
      id: "chargebacks-alerts",
      href: routes.getSettingsSubRoute("chargebacks/alerts"),
      friendlyName: "Alerts",
      UnfilledIcon: AlertCircleIcon,
      FilledIcon: AlertCircleFilledIcon,
    },
    resolveEnabled && {
      id: "chargebacks-resolve",
      href: routes.getSettingsSubRoute("chargebacks/resolve"),
      friendlyName: "Resolve",
      UnfilledIcon: DataflowIcon,
      FilledIcon: DataflowFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.CHARGEBACKS, items };
}

function useConversionSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { checkoutOptimizationEnabled } = useRequiredContext(
    ConversionSuiteStatusesContext,
  );

  const canManageCheckoutOptimizationSettings = useHasPermission(
    SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
  );

  const hsaEnabled = !!team.settings.hsa?.enabled;

  const items: SettingItem[] = filterTruthy([
    checkoutOptimizationEnabled &&
      canManageCheckoutOptimizationSettings && {
        id: "general",
        href: routes.getSettingsSubRoute("conversion/general"),
        friendlyName: "General",
        UnfilledIcon: Settings02Icon,
        FilledIcon: Settings02FilledIcon,
      },
    hsaEnabled &&
      canManageCheckoutOptimizationSettings && {
        id: "hsa",
        href: routes.getSettingsSubRoute("conversion/hsa"),
        friendlyName: "HSA/FSA",
        UnfilledIcon: ActivityHeartIcon,
        FilledIcon: ActivityHeartFilledIcon,
      },
  ]);

  // Only show the section if at least one page is accessible
  if (items.length === 0) {
    return undefined;
  }

  items.sort((a, b) => {
    // sort by friendlyName but make sure "General" is at the top
    if (a.friendlyName === "General") {
      return -1;
    }

    if (b.friendlyName === "General") {
      return 1;
    }

    return a.friendlyName.localeCompare(b.friendlyName);
  });

  return { name: SettingsSectionEnum.CONVERSION, items };
}

function useCustomersSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  // Note: customerAccounts is not part of our centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;
  const canManageCustomersSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );

  if (!customerAccountsEnabled || !canManageCustomersSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "customer-accounts-ad-blocks",
      href: routes.getSettingsSubRoute("customer-accounts-ad-blocks"),
      friendlyName: "Ad blocks",
      UnfilledIcon: Target01Icon,
      FilledIcon: Target01FilledIcon,
    },
    {
      id: "customer-accounts-storefront-display",
      href: routes.getSettingsSubRoute("customer-accounts-storefront-display"),
      friendlyName: "Storefront display",
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.CUSTOMER_ACCOUNTS, items };
}

function useInventoryManagementSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const imsEnabled = team.settings.ims?.enabled;
  const { enabled: imsQuickbooksEnabled } = useTeamFeatureFlag(
    OmsFlagKey.IMS_QUICKBOOKS,
    { forceEnabledForRedoUsers: false },
  );

  const canManageOther = useHasPermission(GeneralPermissions.OTHER);

  if (!imsEnabled || !canManageOther) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "inventory-general",
      href: routes.getSettingsSubRoute("inventory-management/general"),
      friendlyName: "General",
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    {
      id: "inventory-purchase-orders",
      href: routes.getSettingsSubRoute("inventory-management/purchase-orders"),
      friendlyName: "Purchase orders",
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    imsQuickbooksEnabled && {
      id: "inventory-accounting",
      href: routes.getSettingsSubRoute("inventory-management/quickbooks"),
      friendlyName: "Accounting",
      UnfilledIcon: CreditCard01Icon,
      FilledIcon: CreditCard01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.INVENTORY_MANAGEMENT, items };
}

function useFulfillmentSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const canManageFulfillmentSettings = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );

  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  if (
    !(omsEnabled && canManageFulfillmentSettings) &&
    !canManageAdminGeneralSettings
  ) {
    return undefined;
  }

  const omsFulfill = omsEnabled && canManageFulfillmentSettings;

  const items: SettingItem[] = filterTruthy([
    omsFulfill && {
      id: "general-oms",
      href: routes.getSettingsSubRoute("oms/general"),
      friendlyName: "General",
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    omsFulfill && {
      id: "automerge-link",
      href: routes.getSettingsSubRoute("oms/automerge-shipments"),
      friendlyName: "Auto-merge shipments",
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    omsFulfill && {
      id: "automations-oms",
      href: routes.getSettingsSubRoute("oms/automations"),
      friendlyName: "Automations",
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    omsFulfill && {
      id: "custom-import-schemas",
      href: routes.getSettingsSubRoute("oms/custom-import-schemas"),
      friendlyName: "Custom imports",
      UnfilledIcon: DatabaseIcon,
      FilledIcon: DatabaseFilledIcon,
    },
    omsFulfill && {
      id: "international",
      href: routes.getSettingsSubRoute("oms/international"),
      friendlyName: "International",
      UnfilledIcon: Globe02Icon,
      FilledIcon: Globe02FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "order-editing-button",
      href: routes.getSettingsSubRoute("order-management/order-editing"),
      friendlyName: "Order editing",
      UnfilledIcon: Tool01Icon,
      FilledIcon: Tool01FilledIcon,
    },
    omsFulfill && {
      id: "parcels-link",
      href: routes.getSettingsSubRoute("oms/packages"),
      friendlyName: "Packages",
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    omsFulfill && {
      id: "presets-link",
      href: routes.getSettingsSubRoute("oms/presets"),
      friendlyName: "Presets",
      UnfilledIcon: LayersThree02Icon,
      FilledIcon: LayersThree02FilledIcon,
    },
    omsFulfill && {
      id: "printing",
      href: routes.getSettingsSubRoute("oms/printing"),
      friendlyName: "Printing",
      UnfilledIcon: FileCheck02Icon,
      FilledIcon: FileCheck02FilledIcon,
    },
    omsFulfill && {
      id: "reports",
      href: routes.getSettingsSubRoute("oms/reports"),
      friendlyName: "Reports",
      UnfilledIcon: BarChart01Icon,
      FilledIcon: BarChart01FilledIcon,
    },
    omsFulfill && {
      id: "scanning-warehouse",
      href: routes.getSettingsSubRoute("oms/scanning-warehouse"),
      friendlyName: "Scanning & warehouse",
      UnfilledIcon: DatabaseIcon,
      FilledIcon: DatabaseFilledIcon,
    },
    omsFulfill && {
      id: "security",
      href: routes.getSettingsSubRoute("oms/security"),
      friendlyName: "Security",
      UnfilledIcon: Lock01Icon,
      FilledIcon: Lock01FilledIcon,
    },
    omsFulfill && {
      id: "warehouse-layouts",
      href: routes.getSettingsSubRoute("oms/warehouse-layouts"),
      friendlyName: "Warehouse layouts",
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
    omsFulfill && {
      id: "work-order-flows",
      href: routes.getSettingsSubRoute("oms/work-order-flows"),
      friendlyName: "Work order flows",
      UnfilledIcon: Route01Icon,
      FilledIcon: Route01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.ORDER_FULFILLMENT, items };
}

function usePersonalSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);

  const items: SettingItem[] = [
    {
      id: "personal-profile",
      href: routes.getSettingsSubRoute("personal"),
      friendlyName: "Profile",
      UnfilledIcon: UserEditIcon,
      FilledIcon: UserEditFilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.PERSONAL, items };
}

function useGeneralSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { supportEnabled } = useRequiredContext(SupportSuiteStatusesContext);
  // Note: Some settings not in centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const aiEnabled = team.settings.support?.ai?.enabled;
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;

  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );
  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  const canManageSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );
  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );
  const canManageCustomerAccountsSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );
  // Mirrors the /settings/integrations route's any-of permission gate.
  const canAccessIntegrations = useHasPermission(
    ...INTEGRATIONS_HUB_PERMISSIONS,
  );

  const canManageTeamRoles = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_ROLES,
  );

  const canManageChatWidget =
    canManageSupportSettings ||
    canManageAiSettings ||
    canManageCustomerAccountsSettings ||
    canManageAdminGeneralSettings;
  const chatWidgetEnabled =
    supportEnabled || aiEnabled || customerAccountsEnabled;
  // Show customer widget in General only when support is NOT enabled
  const showChatWidgetInGeneral =
    !supportEnabled && chatWidgetEnabled && canManageChatWidget;

  const canManageDeveloperSettings = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_DEVELOPMENT,
  );

  const canManageTeamUsers = useHasPermission(
    GeneralPermissions.MANAGE_TEAM_USERS,
  );

  const canViewBilling = useHasPermission(SettingsPermissions.VIEW_BILLING);
  const canManageBillingSettings = useHasPermission(
    SettingsPermissions.SET_BILLING_SETTINGS,
  );

  const items: SettingItem[] = filterTruthy([
    (canManageAdminGeneralSettings ||
      canViewBilling ||
      canManageBillingSettings) && {
      id: "billing-button",
      href: routes.getSettingsSubRoute("billing"),
      friendlyName: "Billing",
      UnfilledIcon: CreditCard01Icon,
      FilledIcon: CreditCard01FilledIcon,
      children: [
        {
          id: "bills-button",
          href: routes.getSettingsSubRoute("billing/bills"),
          friendlyName: "Bills",
          UnfilledIcon: CreditCard01Icon,
          FilledIcon: CreditCard01FilledIcon,
        },
        {
          id: "billing-activity-button",
          href: routes.getSettingsSubRoute("billing/reports"),
          friendlyName: "Activity",
          UnfilledIcon: BarChart01Icon,
          FilledIcon: BarChart01FilledIcon,
        },
      ],
    },
    canManageAdminGeneralSettings && {
      id: "brand-kit-button",
      href: routes.getSettingsSubRoute("brand-kit"),
      friendlyName: "Brand kit",
      UnfilledIcon: Brush01Icon,
      FilledIcon: Brush01FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "communication-button",
      href: routes.getSettingsSubRoute("communication"),
      friendlyName: "Communication",
      UnfilledIcon: Mail01Icon,
      FilledIcon: Mail01FilledIcon,
    },
    (canManageAdminGeneralSettings || canManageReturnsSettings) && {
      id: "customer-portal-button",
      href: routes.getSettingsSubRoute("customer-portal"),
      friendlyName: "Customer portal",
      UnfilledIcon: UserCircleIcon,
      FilledIcon: UserCircleFilledIcon,
      children: filterTruthy([
        {
          id: "portal-builder",
          href: routes.getSettingsSubRoute("portal-builder"),
          friendlyName: "Portal builder",
          UnfilledIcon: Cursor01Icon,
          FilledIcon: Cursor01FilledIcon,
        },
        canManageReturnsSettings &&
          team.platform === "shopify" && {
            id: "point-of-sale",
            href: routes.getSettingsSubRoute("pos"),
            friendlyName: "Point of sale",
            UnfilledIcon: ShoppingCart01Icon,
            FilledIcon: ShoppingCart01FilledIcon,
          },
        canManageReturnsSettings &&
          canManageTeamRoles && {
            id: "permissions",
            href: routes.getSettingsSubRoute("permissions"),
            friendlyName: "Merchant-created returns",
            UnfilledIcon: Key01Icon,
            FilledIcon: Key01FilledIcon,
          },
      ]),
    },
    showChatWidgetInGeneral && {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: "Customer widget",
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
    },
    canManageDeveloperSettings && {
      id: "developer-button",
      href: routes.getSettingsSubRoute("developer"),
      friendlyName: "Developer",
      UnfilledIcon: CodeBrowserIcon,
      FilledIcon: CodeBrowserFilledIcon,
    },
    canAccessIntegrations && {
      id: "general-integrations",
      href: routes.getSettingsSubRoute("integrations"),
      friendlyName: "Integrations",
      UnfilledIcon: Share07Icon,
      FilledIcon: Share07FilledIcon,
    },
    canManageAdminGeneralSettings && {
      id: "notifications-button",
      href: routes.getSettingsSubRoute("notifications"),
      friendlyName: "Notifications",
      UnfilledIcon: Bell03Icon,
      FilledIcon: Bell03FilledIcon,
    },
    canManageTeamRoles && {
      id: "roles-button",
      href: routes.getSettingsSubRoute("roles"),
      friendlyName: "Roles",
      UnfilledIcon: ShieldTickIcon,
      FilledIcon: ShieldTickFilledIcon,
    },
    canManageTeamUsers && {
      id: "users-button",
      href: routes.getSettingsSubRoute("users"),
      friendlyName: "Users",
      UnfilledIcon: Users01Icon,
      FilledIcon: Users01FilledIcon,
    },
    canManageTeamUsers && {
      id: "user-groups-button",
      href: routes.getSettingsSubRoute("user-groups"),
      friendlyName: "Groups",
      UnfilledIcon: UsersPlusIcon,
      FilledIcon: UsersPlusFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.GENERAL, items };
}

function useMarketingSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { returnTrackingEnabled, emailSmsEnabled, orderTrackingEnabled } =
    useRequiredContext(MarketingCloudStatusesContext);
  const canManageMarketingSettings = useHasPermission(
    SettingsPermissions.SET_MARKETING_SETTINGS,
  );
  const { data: offersBlockFlag } = useRpcQuery(
    RedoPlatformAuthRpcClientContext,
    "getFeatureFlag",
    { flagKey: MarketingFlagKey.OFFERS_TRACKING_PAGE_BLOCK },
  );

  if (
    (!returnTrackingEnabled && !emailSmsEnabled && !orderTrackingEnabled) ||
    !canManageMarketingSettings
  ) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "audience",
      href: routes.getSettingsSubRoute("audience"),
      friendlyName: "Audience",
      UnfilledIcon: Users01Icon,
      FilledIcon: Users01FilledIcon,
    },
    {
      id: "email-domain",
      href: routes.getSettingsSubRoute("email-domain"),
      friendlyName: "Email domain",
      UnfilledIcon: Mail01Icon,
      FilledIcon: Mail01FilledIcon,
    },
    ...(offersBlockFlag?.enabled
      ? [
          {
            id: "offer-page-configuration",
            href: routes.getSettingsSubRoute("offer-page-configuration"),
            friendlyName: "Offer page",
            UnfilledIcon: CoinsStacked03Icon,
            FilledIcon: CoinsStacked03FilledIcon,
          },
        ]
      : []),
    {
      id: "marketing-sms",
      href: routes.getSettingsSubRoute("sms-marketing"),
      friendlyName: "SMS",
      UnfilledIcon: Phone01Icon,
      FilledIcon: Phone01FilledIcon,
    },
    {
      id: "subscribe-keywords",
      href: routes.getSettingsSubRoute("subscribe-keywords"),
      friendlyName: "Keywords",
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    },
    {
      id: "recover-settings",
      href: routes.getSettingsSubRoute("recover-settings"),
      friendlyName: "Recover",
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    // Attribution settings are still in development; only surface the nav link
    // in local dev for now.
    ...(window.location.href.includes("localhost")
      ? [
          {
            id: "attribution",
            href: routes.getSettingsSubRoute("attribution"),
            friendlyName: "Attribution",
            UnfilledIcon: BarChart01Icon,
            FilledIcon: BarChart01FilledIcon,
          },
        ]
      : []),
    {
      id: "marketing-agent",
      href: routes.getSettingsSubRoute("marketing-agent"),
      friendlyName: "Marketing Agent",
      UnfilledIcon: Stars01Icon,
      FilledIcon: Stars01Icon,
    },
  ];

  return { name: SettingsSectionEnum.MARKETING, items };
}

function useOrderTrackingSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { orderTrackingEnabled } = useRequiredContext(
    MarketingCloudStatusesContext,
  );
  const canManageMarketingSettings = useHasPermission(
    SettingsPermissions.SET_MARKETING_SETTINGS,
  );

  if (!orderTrackingEnabled || !canManageMarketingSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "order-tracking-general",
      href: routes.getSettingsSubRoute("order-tracking"),
      friendlyName: "General",
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
  ];

  return { name: SettingsSectionEnum.ORDER_TRACKING, items };
}

function useProductsSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const user = useContext(UserContext);
  const canManageProductsSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  if (!canManageProductsSettings) {
    return;
  }

  const isRedoEmployee = isRedoEmailAddress(user?.email);

  const items: SettingItem[] = filterTruthy([
    isRedoEmployee && {
      id: "attributes-button",
      href: routes.getSettingsSubRoute("attributes"),
      friendlyName: "Attributes",
      UnfilledIcon: LayersThree02Icon,
      FilledIcon: LayersThree02FilledIcon,
    },
    {
      id: "products-button",
      href: routes.getSettingsSubRoute("products"),
      friendlyName: "Products",
      UnfilledIcon: ShoppingBag01Icon,
      FilledIcon: ShoppingBag01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.PRODUCTS, items };
}

function useReturnsSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  if (!canManageReturnsSettings) {
    return undefined;
  }

  const is3PL = team.teamType === TeamType.FulfillmentService;
  const wmsSotAnywhere =
    team.settings?.outboundLabels?.wms?.sourceOfTruthEnabled === true;
  const showWmsReturnsSettings = is3PL || wmsSotAnywhere;

  const items: SettingItem[] = filterTruthy([
    {
      id: "assessments",
      href: routes.getSettingsSubRoute("assessments"),
      friendlyName: "Assessments",
      UnfilledIcon: FileCheck02Icon,
      FilledIcon: FileCheck02FilledIcon,
    },
    {
      id: "automations-button",
      href: routes.getSettingsSubRoute("automations"),
      friendlyName: "Automations",
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    {
      id: "coverage-button",
      href: routes.getSettingsSubRoute("coverage"),
      friendlyName: "Coverage",
      UnfilledIcon: ShieldTickIcon,
      FilledIcon: ShieldTickFilledIcon,
    },
    {
      id: "exchanges-button",
      href: routes.getSettingsSubRoute("exchanges"),
      friendlyName: "Exchanges",
      UnfilledIcon: RefreshCw01Icon,
      FilledIcon: RefreshCw01FilledIcon,
    },
    {
      id: "return-processing-button",
      href: routes.getSettingsSubRoute("automations/processing"),
      friendlyName: "Processing",
      UnfilledIcon: FilterLinesIcon,
      FilledIcon: FilterLinesFilledIcon,
    },
    {
      id: "processing-button",
      href: routes.getSettingsSubRoute("processing"),
      friendlyName: "Refunds & store credit",
      UnfilledIcon: Coins01Icon,
      FilledIcon: Coins01FilledIcon,
    },
    is3PL && {
      id: "processing-groups",
      href: routes.getSettingsSubRoute("processing-groups"),
      friendlyName: "Processing groups",
      UnfilledIcon: LayoutGrid01Icon,
      FilledIcon: LayoutGrid01FilledIcon,
    },
    showWmsReturnsSettings && {
      id: "post-processing",
      href: routes.getSettingsSubRoute("post-processing"),
      friendlyName: "Post processing",
      UnfilledIcon: Route01Icon,
      FilledIcon: Route01FilledIcon,
    },
    is3PL && {
      id: "consolidation",
      href: routes.getSettingsSubRoute("consolidation"),
      friendlyName: "Consolidation",
      UnfilledIcon: PackageIcon,
      FilledIcon: PackageFilledIcon,
    },
    {
      id: "shipping-button",
      href: routes.getSettingsSubRoute("shipping"),
      friendlyName: "Shipping",
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    },
    {
      id: "returns-ui",
      href: routes.getSettingsSubRoute("returns-ui"),
      friendlyName: "Return detail view",
      UnfilledIcon: Monitor01Icon,
      FilledIcon: Monitor01FilledIcon,
    },
    {
      id: "warehouse-button",
      href: routes.getSettingsSubRoute("warehouse"),
      friendlyName: "Warehouse",
      UnfilledIcon: WarehouseIcon,
      FilledIcon: WarehouseFilledIcon,
    },
    {
      id: "withdrawals",
      href: routes.getSettingsSubRoute("withdrawals"),
      friendlyName: "Withdrawals",
      UnfilledIcon: XCircleIcon,
      FilledIcon: XCircleFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.RETURNS_AND_CLAIMS, items };
}

function useWarrantiesSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { warrantiesEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const team = useRequiredContext(TeamContext);
  const registrationRewardsEnabled =
    team.settings.warranties?.registrationRewardType !==
    RegistrationRewardType.DISABLED;

  const canManageWarrantiesSettings = useHasPermission(
    SettingsPermissions.SET_WARRANTY_SETTINGS,
  );

  if (!warrantiesEnabled || !canManageWarrantiesSettings) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    {
      id: "registration-settings",
      href: routes.getSettingsSubRoute("registrations"),
      friendlyName: "Registration",
      UnfilledIcon: Pencil01Icon,
      FilledIcon: Pencil01FilledIcon,
    },
    registrationRewardsEnabled && {
      id: "warranty-registration-button",
      href: routes.getSettingsSubRoute("registration-rewards"),
      friendlyName: "Registration rewards",
      UnfilledIcon: Award01Icon,
      FilledIcon: Award01FilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.WARRANTIES, items };
}

function useInternationalSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const marketsEnabled = !!team?.settings?.landedCost?.enableMarkets;
  const canManageInternationalSettings = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );
  const canManageReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    SettingsPermissions.SET_SHIPPING_SETTINGS,
  );

  if (!canManageInternationalSettings && !canManageReturnsSettings) {
    return undefined;
  }

  const items: SettingItem[] = [];

  if (canManageInternationalSettings) {
    items.push({
      id: "international-customs",
      href: routes.getSettingsSubRoute("international/customs"),
      friendlyName: "Customs",
      UnfilledIcon: FileCheck02Icon,
      FilledIcon: FileCheck02FilledIcon,
    });

    if (marketsEnabled) {
      items.push({
        id: "international-markets",
        href: routes.getSettingsSubRoute("international/markets"),
        friendlyName: "Markets",
        UnfilledIcon: Globe02Icon,
        FilledIcon: Globe02FilledIcon,
      });
    }
  }

  if (canManageReturnsSettings) {
    items.push({
      id: "international-returns",
      href: routes.getSettingsSubRoute("international/returns"),
      friendlyName: "International Returns",
      UnfilledIcon: FlipBackwardIcon,
      FilledIcon: FlipBackwardFilledIcon,
    });
  }

  return { name: SettingsSectionEnum.INTERNATIONAL, items };
}

function useShippingSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const canManageShippingSettings = useHasPermission(
    SettingsPermissions.SET_SHIPPING_SETTINGS,
  );

  if (!canManageShippingSettings) {
    return undefined;
  }

  // cspell:disable-next-line
  // Third party TESCOM teams should not have access to shipping settings
  const hideTeams = [
    "68a50f1378bdf9a9c1352e8b",
    "68a51f39ad07ff22f074fb25",
    "68a51f7715aa9428462967c6",
    "68a52001e14afead23f253cd",
    "68a51fbf1aa2c4f5c2b6c0c3",
  ];

  const hideShippingSettings = team?._id && hideTeams.includes(team?._id);
  if (hideShippingSettings) {
    return undefined;
  }

  const items: SettingItem[] = [
    {
      id: "carriers-link",
      href: routes.getSettingsSubRoute("carriers"),
      friendlyName: "Carriers",
      UnfilledIcon: Truck01Icon,
      FilledIcon: Truck01FilledIcon,
    },
    {
      id: "fulfillment-cutoff-link",
      href: routes.getSettingsSubRoute("fulfillment-cutoff"),
      friendlyName: "Fulfillment promise",
      UnfilledIcon: Announcement02Icon,
      FilledIcon: Announcement02FilledIcon,
    },
    {
      id: "freight-link",
      href: routes.getSettingsSubRoute("freight"),
      friendlyName: "Freight",
      UnfilledIcon: Map01Icon,
      FilledIcon: Map01FilledIcon,
    },
  ];

  const lcgEnabled = !!team?.settings?.landedCost?.enabled;

  if (lcgEnabled) {
    items.push({
      id: "shipping-discounts-link",
      href: routes.getSettingsSubRoute("discounts"),
      friendlyName: "Discounts",
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    });
  }

  if (lcgEnabled && !omsEnabled) {
    items.push({
      id: "cross-border-link",
      href: routes.getSettingsSubRoute("cross-border"),
      friendlyName: "Cross border",
      UnfilledIcon: Globe02Icon,
      FilledIcon: Globe02FilledIcon,
    });
  }

  return { name: SettingsSectionEnum.SHIPPING, items };
}

function useSupportSettings(): SettingsSection | undefined {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { supportEnabled } = useRequiredContext(SupportSuiteStatusesContext);
  // Note: Some settings not in centralized suites yet, keeping team access
  const team = useRequiredContext(TeamContext);
  const aiEnabled = team.settings.support?.ai?.enabled;
  const customerAccountsEnabled = team.settings.customerAccounts?.enabled;

  const canManageSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );

  const canManageAiSettings = useHasPermission(
    SettingsPermissions.SET_AI_SETTINGS,
  );
  const canManageCustomerAccountsSettings = useHasPermission(
    SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
  );
  const canManageAdminGeneralSettings = useHasPermission(
    SettingsPermissions.SET_GENERAL_SETTINGS,
  );

  const canManageChatWidget =
    canManageSupportSettings ||
    canManageAiSettings ||
    canManageCustomerAccountsSettings ||
    canManageAdminGeneralSettings;
  const chatWidgetEnabled =
    supportEnabled || aiEnabled || customerAccountsEnabled;
  // Show customer widget in Support only when support IS enabled
  const showChatWidgetInSupport =
    supportEnabled && chatWidgetEnabled && canManageChatWidget;

  // Allow Support section to render if either:
  // 1. User has support enabled AND support settings permissions (for support features)
  // 2. User has support enabled AND customer widget permissions (for customer widget only)
  if (!supportEnabled || (!canManageSupportSettings && !canManageChatWidget)) {
    return undefined;
  }

  const items: SettingItem[] = filterTruthy([
    canManageSupportSettings && {
      id: "support-general",
      href: routes.getSettingsSubRoute("general"),
      friendlyName: "General",
      UnfilledIcon: Settings02Icon,
      FilledIcon: Settings02FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-customer-satisfaction",
      href: routes.getSettingsSubRoute("customer-satisfaction"),
      friendlyName: "Customer satisfaction",
      UnfilledIcon: UserCheck01Icon,
      FilledIcon: UserCheck01FilledIcon,
    },
    showChatWidgetInSupport && {
      id: "customer-widget-button",
      href: routes.getSettingsSubRoute("customer-widget"),
      friendlyName: "Customer widget",
      UnfilledIcon: MessageChatCircleIcon,
      FilledIcon: MessageChatCircleFilledIcon,
    },
    canManageSupportSettings && {
      id: "support-channels",
      href: routes.getSettingsSubRoute("channels"),
      friendlyName: "Channels",
      UnfilledIcon: Inbox01Icon,
      FilledIcon: Inbox01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-tags",
      href: routes.getSettingsSubRoute(`${"tags"}`),
      friendlyName: "Tags",
      UnfilledIcon: Tag01Icon,
      FilledIcon: Tag01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-macros",
      href: routes.getSettingsSubRoute("macros"),
      friendlyName: "Macros",
      UnfilledIcon: ZapIcon,
      FilledIcon: ZapFilledIcon,
    },
    canManageSupportSettings && {
      id: "support-topics",
      href: routes.getSettingsSubRoute("topics"),
      friendlyName: "Topics",
      UnfilledIcon: MessageSquare01Icon,
      FilledIcon: MessageSquare01FilledIcon,
    },
    canManageSupportSettings && {
      id: "support-faq",
      href: routes.getSettingsSubRoute("faq"),
      friendlyName: "FAQs",
      UnfilledIcon: ListIcon,
      FilledIcon: ListFilledIcon,
    },
    canManageSupportSettings && {
      id: "support-rules",
      href: routes.getSettingsSubRoute("rules"),
      friendlyName: "Rules",
      UnfilledIcon: FilterLinesIcon,
      FilledIcon: FilterLinesFilledIcon,
    },
  ]);

  return { name: SettingsSectionEnum.SUPPORT, items };
}
